export default __webpack_public_path__ + "static/media/Ontraccr-Fav-W-300x300.a2c29ff9.png";